// AI 在忙的样子：点阵小球（thinking-orbs，MIT），按在做的事换动作——理解问题像魔方在转、查资料像地球在扫、
// 推理像几股线在编、写回答像一条飘带；旁边一行流光的字和走着的秒数（参考 beautifului.dev 的 Loading State）。
// 闲着时是不动的点阵（不用「灵」字标）。颜色跟深浅外观走，用户开了「减少动态效果」就只画一帧。

import { useEffect, useState } from 'react'
import { ThinkingOrb, type OrbState } from 'thinking-orbs'
import { useAppearanceSettings } from '../theme/ThemeProvider'

export type { OrbState }

/** 灵智原生回答过程里的一步 → 用哪个动作。 */
export function orbFor(step?: string): OrbState {
  switch (step) {
    case 'query_understand':
      return 'solving'
    case 'knowledge_search':
    case 'grep_chunks':
    case 'list_knowledge_chunks':
    case 'get_document_info':
    case 'wiki_search':
      return 'searching'
    case 'web_search':
    case 'web_fetch':
      return 'connecting'
    case 'thinking':
      return 'weaving'
    case 'answer':
      return 'composing'
    default:
      return 'working'
  }
}

export function Orb({ state = 'working', size = 20, paused, className }: { state?: OrbState; size?: 20 | 32 | 64; paused?: boolean; className?: string }) {
  const { isDark } = useAppearanceSettings()
  return <ThinkingOrb state={state} size={size} paused={paused} theme={isDark ? 'dark' : 'light'} className={className} aria-hidden="true" />
}

/** 从 since 起走着的秒数（0.1 秒一跳）。 */
export function useElapsed(since: number | null) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (since === null) return
    const t = setInterval(() => setNow(Date.now()), 100)
    return () => clearInterval(t)
  }, [since])
  return since === null ? 0 : Math.max(0, now - since) / 1000
}

/** 一行「正在做什么…  3.2s」：小球 + 流光的字 + 秒数。 */
export function Working({ label, state = 'working', since }: { label: string; state?: OrbState; since?: number | null }) {
  const [start] = useState(() => since ?? Date.now())
  const s = useElapsed(start)
  return (
    <span className="sk-working" role="status">
      <Orb state={state} size={20} />
      <span className="shimmer">{label}</span>
      <span className="sk-working-t" aria-hidden="true">
        {s.toFixed(1)}s
      </span>
    </span>
  )
}
